import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../Modal/Modal";
import { CancelButton } from "../StandardButtons/StandardButtons";
import FAIcon from "../FAIcon/FAIcon";
const Confirm = ({ modalId, isOpen, confirmationText, onModalClosed, confirmButtonLabel, confirmButtonClassName, cancelButtonLabel, }) => {
    const pressedButton = React.useRef(false);
    React.useEffect(() => {
        if (isOpen) {
            pressedButton.current = false;
        }
    }, [isOpen]);
    return (_jsxs(Modal, { appendToBody: true, isOpen: isOpen || false, modalId: modalId, onModalClosed: () => {
            if (!pressedButton.current) {
                onModalClosed(false);
            }
        }, children: [_jsx("div", { className: "modal-header", children: _jsx("h5", { children: "Confirmation" }) }), _jsx("div", { className: "modal-body", children: confirmationText || "Are you sure?" }), _jsxs("div", { className: "modal-footer", children: [_jsxs("button", { type: "button", className: confirmButtonClassName !== null && confirmButtonClassName !== void 0 ? confirmButtonClassName : "btn btn-primary mr-2", onClick: () => {
                            pressedButton.current = true;
                            onModalClosed(true);
                        }, children: [_jsx(FAIcon, { icon: "check", className: "mr-2" }), confirmButtonLabel !== null && confirmButtonLabel !== void 0 ? confirmButtonLabel : "Ok"] }), _jsx(CancelButton, { onClick: () => {
                            pressedButton.current = true;
                            onModalClosed(false);
                        }, overrideLabel: cancelButtonLabel !== null && cancelButtonLabel !== void 0 ? cancelButtonLabel : undefined })] })] }));
};
export default Confirm;
